import React, { useState } from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/Section';
import { TermsModal } from './TermsModal';
export function FooterCTA() {
  const [showTerms, setShowTerms] = useState(false);
  return <footer id="pricing" className="bg-[#3D1F2E]/80 text-[#FFF5F0] py-24 px-6 text-center" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <FadeIn data-id="element-48">
          <h2 className="text-4xl md:text-5xl font-serif mb-8 leading-tight" data-id="element-49">
            Si estás cansada de prometerte que vas a cambiar "mañana"…
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-50">
          <p className="text-xl md:text-2xl text-[#E8D5DC] mb-12 font-light" data-id="element-51">
            y quieres una estructura que funcione cuando estás vulnerable…{' '}
            <br data-id="element-52" />
            <span className="text-[#C4467E] font-medium" data-id="element-53">
              Anti‑Impulso es tu punto de inicio.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-54">
          <div className="bg-[#FFF5F0]/90 backdrop-blur-sm text-[#3D1F2E] p-8 md:p-12 rounded-2xl max-w-lg mx-auto shadow-2xl mb-12" data-id="element-55">
            <img src="https://cdn.magicpatterns.com/uploads/h241stnUBcHgWd2SzzrFSw/Anti_impulso_cover.png" alt="Anti-Impulso — Producto digital" className="w-full max-w-xs mx-auto rounded-xl mb-6 -mt-2" data-id="element-56" />
            <div className="text-sm uppercase tracking-widest text-[#7A5C6B] mb-2" data-id="element-57">
              Oferta Especial
            </div>
            <div className="text-5xl font-serif font-bold mb-2" data-id="element-58">
              $129{' '}
              <span className="text-lg font-sans font-normal text-[#7A5C6B]" data-id="element-59">
                MXN
              </span>
            </div>
            <p className="text-[#7A5C6B] mb-8 text-sm" data-id="element-60">
              Pago único. Acceso de por vida.
            </p>

            <Button size="lg" className="w-full mb-4 shadow-xl" withArrow onClick={() => window.open('https://pay.hotmart.com/N104385148Q', '_blank')} data-id="element-61">
              Entrar hoy y empezar Día 1
            </Button>

            <p className="text-xs text-[#7A5C6B] mt-4" data-id="element-62">
              Garantía de 30 días. Si no te sirve, te devolvemos tu dinero.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-63">
          <p className="text-lg font-serif italic text-[#E8D5DC]" data-id="element-64">
            No para volverte perfecta. <br data-id="element-65" />
            Para volver a sentirte en control.
          </p>
        </FadeIn>

        <div className="mt-24 text-[#7A5C6B] text-sm border-t border-[#7A5C6B]/30 pt-8 space-y-2" data-id="element-66">
          <p data-id="element-67">
            © {new Date().getFullYear()} Anti-Impulso. Todos los derechos
            reservados.
          </p>
          <button onClick={() => setShowTerms(true)} className="underline hover:text-[#E8D5DC] transition-colors cursor-pointer" data-id="element-68">
            Términos y Condiciones
          </button>
        </div>
      </div>

      <TermsModal isOpen={showTerms} onClose={() => setShowTerms(false)} data-id="element-69" />
    </footer>;
}